<div class="feedback-step">
  <div class="step-header">
    <h3>{{ stepData.categoryTitle }}</h3>
  </div>

  <form class="questions-container" [formGroup]="formGroup">
    <div formArrayName="questionResponses">
      <div
        *ngFor="let question of stepData.questions; let i = index"
        class="question-item"
        [formGroupName]="getQuestionIndex(question.id)">
        <div class="header-with-cta mb-16">
          <div class="quetion-badge">
            <span class="badge"
              >{{ i + 1 }}/{{ stepData.questions.length }}</span
            >
            <h3 class="title s-18">{{ question.question }}</h3>
          </div>
        </div>

        <nz-form-control
          [nzErrorTip]="getQuestionErrorTip(question.id)"
          [nzValidateStatus]="getQuestionValidationStatus(question.id)"
          [nzHasFeedback]="true">
          <div class="radio-wrapper">
            <nz-radio-group
              formControlName="ratingScale"
              class="radio-group stakeholder-group"
              [disabled]="stepData.isViewMode">
              <span nz-radio [nzValue]="1" class="box-radio">
                <span class="radio-label">{{
                  getProgressLabel(question, 1)
                }}</span>
              </span>
              <span nz-radio [nzValue]="2" class="box-radio">
                <span class="radio-label">{{
                  getProgressLabel(question, 2)
                }}</span>
              </span>
              <span nz-radio [nzValue]="3" class="box-radio">
                <span class="radio-label">{{
                  getProgressLabel(question, 3)
                }}</span>
              </span>
              <span nz-radio [nzValue]="4" class="box-radio">
                <span class="radio-label">{{
                  getProgressLabel(question, 4)
                }}</span>
              </span>
              <span nz-radio [nzValue]="5" class="box-radio">
                <span class="radio-label">{{
                  getProgressLabel(question, 5)
                }}</span>
              </span>
            </nz-radio-group>
          </div>
        </nz-form-control>

        <hr class="question-divider" />
      </div>
    </div>
  </form>
</div>
